import React from "react";
import MetricStatCard from "./MetricStatCard";
import { formatVolunteeringHoursValue } from "../shared/utils/volunteerOpportunityDisplay";

/**
 * Summary for Volunteer Participants: count and total volunteering hours for displayed rows.
 */
export default function VolunteerParticipantsSummaryStatCards({
  participantCount,
  totalVolunteeringHours,
  style,
  className,
}) {
  const count = Number(participantCount) || 0;
  const hours = Number(totalVolunteeringHours) || 0;
  return (
    <div
      className={`cards-wrapper cards-wrapper--sm cards-wrapper--summary-compact${
        className ? ` ${className}` : ""
      }`}
      style={style}
      role="region"
      aria-label="Volunteer participants summary"
    >
      <MetricStatCard
        label="Total Records"
        value={count.toLocaleString(undefined, { maximumFractionDigits: 0 })}
        valueStyle={{ color: "#2563eb" }}
      />
      <MetricStatCard
        label="Total Volunteering Hours"
        value={formatVolunteeringHoursValue(hours, { emptyLabel: "0 hr" })}
        valueStyle={{ color: "#16a34a" }}
      />
    </div>
  );
}
